<template>
  <div class="row">
    <div class="col-md-12">

      <template>
  <div>
    <div class="range-buttons " v-if="sugggestdata?.id !== null ">
      <reservation-link
        :sugggestdata="sugggestdata"
        :destinationUri="destinationdata.destination.destination.uri"
      />
    </div>
  </div>
</template>


      <div class="row">
        <div class="col-md-8">
          <Carousel :style="{ marginLeft: '5px' }" :galleries="destinationdata.destination.gallery" />
        </div>
        <div class="col-md-4">
          <Weather :forecastDays="destinationdata.destination.weather.forecastDays"
            :destination="destinationdata.destination" />
        </div>
      </div>
      <div class="table-content-toggle">
        <Food :food="destinationdata.destination.food" :city="destinationdata.destination.baseName"
          :countryName="destinationdata.destination.countryName" />
        <weather-toggle :weather="destinationdata.destination.weather" :city="destinationdata.destination.baseName"
          :countryName="destinationdata.destination.countryName" />
        <Similar :similarDestination="destinationdata.similarDestination"
          :destination="destinationdata.destination.countryName" />
      </div>

    </div>
  </div>
</template>
  
<script>
import { DestinationServices } from '../../services/DestinationService';
import { SuggestServices } from '../../services/SuggestService';



export default {
  props: {
    msg: String,
  },
  data() {
    return {
      name: "Nombre",
      destinationdata: DestinationServices.GetContent(),
      sugggestdata: SuggestServices.GetContent()
    };
  },
};
</script>
